<template>
  <div class="app-container">
    <div>List of blogs private for members</div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        prop="title"
        label="Title">
      </el-table-column>
      <el-table-column
        prop="link"
        label="Link">
        <template slot-scope="scope">
          <a href="#" @click="openLink(scope.row.link)">{{ scope.row.link }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="password"
        label="Password">
        <template slot-scope="scope">
          <span>2114</span>
        </template>
      </el-table-column>
  </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BlogResource from '@/api/blog'
import { param } from '@/utils'
import request from '@/utils/request'

const blogResource = new BlogResource()

export default {
  name: 'Blogs',
  components: {},
  data() {
    return {
      tableData: []
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  created() {
    // fetch protected posts from wordpress
    this.getBlogList()
  },
  methods: {
    async getBlogList() {
      const { blogs } = await blogResource.getBlogList()
      this.tableData = blogs
    },

    openLink(link) {
      window.open(link, '_blank')
    }
  }
}
</script>
